import { AGING_LABEL, fmtMoney } from "./apUtils";

function Kpi({ label, value, sub, testid, tone }) {
  return (
    <div className="border border-brand-border bg-brand-surface rounded-xl px-5 py-4" data-testid={testid}>
      <p className="text-[10px] uppercase tracking-[0.15em] text-brand-tertiary">{label}</p>
      <p className={`font-serif text-3xl font-light mt-1 ${tone || "text-brand-ink"}`}>{value}</p>
      {sub && <p className="text-xs text-brand-muted mt-1">{sub}</p>}
    </div>
  );
}

export function ApSummary({ summary }) {
  if (!summary) return null;
  const s = summary.by_status;
  const openCount = ["received", "approved", "scheduled", "disputed"].reduce((n, k) => n + s[k].count, 0);
  const agingMax = Math.max(1, ...Object.values(summary.aging));
  return (
    <div className="grid lg:grid-cols-[1fr_1fr] gap-4">
      <div className="grid grid-cols-2 gap-4">
        <Kpi label="Open payables" value={fmtMoney(summary.open_total)} sub={`${openCount} invoice${openCount === 1 ? "" : "s"}`} testid="ap-kpi-open" />
        <Kpi label="Overdue" value={fmtMoney(summary.overdue_total)} tone={summary.overdue_total > 0 ? "text-rose-700" : undefined} testid="ap-kpi-overdue" />
        <Kpi label="Awaiting approval" value={s.received.count} sub={fmtMoney(s.received.amount)} testid="ap-kpi-received" />
        <Kpi label="Paid this month" value={fmtMoney(summary.paid_this_month)} testid="ap-kpi-paid-month" />
      </div>
      <div className="border border-brand-border bg-brand-surface rounded-xl px-5 py-4" data-testid="ap-aging">
        <p className="text-[10px] uppercase tracking-[0.15em] text-brand-tertiary mb-3">Aging of open payables</p>
        <div className="space-y-2">
          {Object.entries(summary.aging).map(([k, v]) => (
            <div key={k} className="grid grid-cols-[96px_1fr_96px] items-center gap-3 text-xs" data-testid={`ap-aging-${k}`}>
              <span className="text-brand-muted">{AGING_LABEL[k]}</span>
              <div className="h-2 rounded-full bg-brand-hover overflow-hidden">
                <div className={`h-full rounded-full transition-[width] duration-500 ${k === "current" || k === "no_due_date" ? "bg-brand-ink/60" : "bg-rose-500/80"}`} style={{ width: `${(v / agingMax) * 100}%` }} />
              </div>
              <span className="text-right font-mono text-brand-ink">{fmtMoney(v)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
